import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

// Import Bootstrap but prevent auto-initialization that interferes with navigation
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Stimulus setup
import { Application } from "@hotwired/stimulus"
import PreviewIframeController from "./controllers/preview_iframe_controller"
import LinkFeedbackController from "./controllers/link_feedback_controller"
import UpscaleController from "./controllers/upscale_controller"
import NavHealthController from "./controllers/nav_health_controller"
import ToastController from "./controllers/toast_controller"
import ColorPickerController from "./controllers/color_picker_controller"
import TooltipController from "./controllers/tooltip_controller"
import CustomizeController from "./controllers/customize_controller"
import FeatureToggleController from "./controllers/feature_toggle_controller"
import SagemakerDetailsController from "./controllers/sagemaker_details_controller"

import CloudwatchLogsController from "./controllers/cloudwatch_logs_controller"
import RevertConfirmationController from "./controllers/revert_confirmation_controller"
import NavbarActionsController from "./controllers/navbar_actions_controller"
import BatchActionsController from "./controllers/batch_actions_controller"
import AutoReloadController from "./controllers/auto_reload_controller"
import SearchController from "./controllers/search_controller"
import UserSelectController from "./controllers/user_select_controller"
import SearchOverlayController from "./controllers/search_overlay_controller"
import DropdownHoverController from "./controllers/dropdown_hover_controller"
import DropdownCloseController from "./controllers/dropdown_close_controller"
import MobileNavController from "./controllers/mobile_nav_controller"
import RefreshController from "./controllers/refresh_controller"
import ShineController from "./controllers/shine_controller"
import ShareController from "./controllers/share_controller"
import SpinshotNavController from "./controllers/spinshot_nav_controller"
import SpinshotFeaturesController from "./controllers/spinshot_features_controller"
import ParallaxController from "./controllers/parallax_controller"
import TechSpecsRevealController from "./controllers/tech_specs_reveal_controller"
import PrivacyRadioController from "./controllers/privacy_radio_controller"
import DomainRestrictionsController from "./controllers/domain_restrictions_controller"
import InstructionsToggleController from "./controllers/instructions_toggle_controller"
import SharePrivacyController from "./controllers/share_privacy_controller"
import EmbedImageController from "./controllers/embed_image_controller"
import PreviewSpinController from "./controllers/preview_spin_controller"
import ExportMp4Controller from "./controllers/export_mp4_controller"
import ExportGifController from "./controllers/export_gif_controller"
import VariantStatusPollController from "./controllers/variant_status_poll_controller"
import WalkthroughController from "./controllers/walkthrough_controller"
import JobErrorModalController from "./controllers/job_error_modal_controller"
import AdminJobsBatchController from "./controllers/admin_jobs_batch_controller"
import UploadFormController from "./controllers/upload_form_controller"
import DirectUploadController from "./controllers/direct_upload_controller"
import PaymentFormController from "./controllers/payment_form_controller"

window.Stimulus = Application.start()
Stimulus.register("preview-iframe", PreviewIframeController)
Stimulus.register("link-feedback", LinkFeedbackController)
Stimulus.register("upscale", UpscaleController)
Stimulus.register("nav-health", NavHealthController)
Stimulus.register("toast", ToastController)
Stimulus.register("color-picker", ColorPickerController)
Stimulus.register("tooltip", TooltipController)
Stimulus.register("customize", CustomizeController)
Stimulus.register("feature-toggle", FeatureToggleController)
Stimulus.register("sagemaker-details", SagemakerDetailsController)

Stimulus.register("cloudwatch-logs", CloudwatchLogsController)
Stimulus.register("revert-confirmation", RevertConfirmationController)
Stimulus.register("navbar-actions", NavbarActionsController)
Stimulus.register("batch-actions", BatchActionsController)
Stimulus.register("auto-reload", AutoReloadController)
Stimulus.register("search", SearchController)
Stimulus.register("user-select", UserSelectController)
Stimulus.register("search-overlay", SearchOverlayController)
Stimulus.register("dropdown-hover", DropdownHoverController)
Stimulus.register("dropdown-close", DropdownCloseController)
Stimulus.register("mobile-nav", MobileNavController)
Stimulus.register("refresh", RefreshController)
Stimulus.register("shine", ShineController)
Stimulus.register("share", ShareController)
Stimulus.register("spinshot-nav", SpinshotNavController)
Stimulus.register("spinshot-features", SpinshotFeaturesController)
Stimulus.register("parallax", ParallaxController)
Stimulus.register("tech-specs-reveal", TechSpecsRevealController)
Stimulus.register("privacy-radio", PrivacyRadioController)
Stimulus.register("domain-restrictions", DomainRestrictionsController)
Stimulus.register("instructions-toggle", InstructionsToggleController)
Stimulus.register("share-privacy", SharePrivacyController)
Stimulus.register("embed-image", EmbedImageController)
Stimulus.register("preview-spin", PreviewSpinController)
Stimulus.register("export-mp4", ExportMp4Controller)
Stimulus.register("export-gif", ExportGifController)
Stimulus.register("variant-status-poll", VariantStatusPollController)
Stimulus.register("walkthrough", WalkthroughController)
Stimulus.register("job-error-modal", JobErrorModalController)
Stimulus.register("admin-jobs-batch", AdminJobsBatchController)
Stimulus.register("upload-form", UploadFormController)
Stimulus.register("direct-upload", DirectUploadController)
Stimulus.register("payment-form", PaymentFormController)


// Attach Bootstrap plugins to jQuery
// Remove global tooltip initialization event listeners and functions

$.fn.toast = function (options) {
    return this.each(function () {
        new bootstrap.Toast(this, options);
    });
};

import "jquery-ujs"
import "chartkick"
import "chartkick/chart.js"
import "trix"
import "@hotwired/turbo"
import "@hotwired/turbo-rails"

// Import local modules
import "./modules/general"
import "./modules/upload_common"
import "./modules/upload_normal"
import "./modules/upload_gallery"
import "./modules/upload_folder"
import "./modules/upload_multirow"
import "./modules/upload_video"
import "./modules/domains"
import "./modules/account"
import "./modules/admin"
import "./modules/static_pages"
import "./modules/embed"
import "./modules/edit"
import "./modules/projects"
import "./modules/variants"
import "./modules/users"
import "./modules/upgrade"
import "./modules/refresh"
import "./modules/s3"
import "./modules/plugins"
import "./modules/upscale"
import "./modules/image"
import "./modules/hotspot_editor"
import "./modules/hotspot_preview"
import "./modules/invite-client"
import "./modules/customize"
import "./modules/customize_autospin"
import "./modules/customize_manualspin"
import "./modules/customize_instruction"
import "./modules/customization_defaults"
import "./modules/viewer_global"
import "./modules/file_reader"
import "./modules/upload_aside"
import "./modules/share_aside"
import "./modules/scroll_indicator_simple"
import "./modules/logo_processing"

// Preload helper
$.fn.preload = function () {
    this.each(function () {
        $('<img/>')[0].src = this;
    });
}

import * as ActionCable from '@rails/actioncable'
ActionCable.logger.enabled = true

import "./channels"

import "./controllers/turbo_stream_actions"

// Auto-attach shine controller to all dark indigo feature cards across views
function attachShineControllers() {
    const cards = document.querySelectorAll('.feature-card-dark-indigo')
    cards.forEach((el) => {
        const existing = el.getAttribute('data-controller') || ''
        if (!existing.split(/\s+/).includes('shine')) {
            el.setAttribute('data-controller', (existing ? existing + ' ' : '') + 'shine')
        }
    })
}

document.addEventListener('turbo:load', attachShineControllers)
document.addEventListener('DOMContentLoaded', attachShineControllers)
